// src/platforms.js
// Single-platform downloader pages:  downr.org/<PAGE_PREFIX>/<slug>/
// e.g. /k7x2q9/instagram-downloader/  and  /k7x2q9/tiktok-downloader/
//
// To add another site later, add one entry below AND the same id/domains to
// PLATFORMS in netlify/functions/bbc.js (the server enforces it too).

// The fixed "random" part of the URL. Change it here, and only here.
export const PAGE_PREFIX = "k7x2q9";

export const PLATFORM_PAGES = {
  instagram: {
    id: "instagram",
    label: "Instagram",
    slug: "instagram-downloader",
    domains: ["instagram.com"],
    title: "Instagram Video Downloader - Download Instagram Reels, Videos & Photos | Downr",
    description: "Download Instagram videos, reels and photos for free. Paste an Instagram link and save it in seconds. No registration or app required.",
    heading: "Instagram Downloader",
  },
  tiktok: {
    id: "tiktok",
    label: "TikTok",
    slug: "tiktok-downloader",
    domains: ["tiktok.com"],
    title: "TikTok Video Downloader - Download TikTok Videos Without Watermark | Downr",
    description: "Download TikTok videos for free. Paste a TikTok link and save the video or audio in seconds. No registration or app required.",
    heading: "TikTok Downloader",
  },
  youtube: {
    id: "youtube",
    label: "YouTube",
    slug: "youtube-downloader",
    domains: ["youtube.com", "youtu.be"],
    title: "YouTube Video Downloader - Download YouTube Videos & Audio Free | Downr",
    description: "Download YouTube videos and audio for free. Paste a YouTube link and choose a format in seconds. No registration or app required.",
    heading: "YouTube Downloader",
  },
  facebook: {
    id: "facebook",
    label: "Facebook",
    slug: "facebook-downloader",
    domains: ["facebook.com", "fb.watch", "fb.com"],
    title: "Facebook Video Downloader - Download Facebook Videos & Reels Free | Downr",
    description: "Download Facebook videos and reels for free. Paste a Facebook link and save it in seconds. No registration or app required.",
    heading: "Facebook Downloader",
  },
  twitter: {
    id: "twitter",
    label: "Twitter (X)",
    slug: "twitter-downloader",
    domains: ["twitter.com", "x.com", "t.co"],
    title: "Twitter (X) Video Downloader - Download Twitter Videos & GIFs Free | Downr",
    description: "Download Twitter (X) videos and GIFs for free. Paste a tweet link and save the video in seconds. No registration or app required.",
    heading: "Twitter (X) Downloader",
  },
};

// true when `rawUrl` is on one of the platform's domains (or a subdomain, e.g. vm.tiktok.com)
export function urlMatchesPlatform(rawUrl, platform) {
  try {
    const { hostname } = new URL(String(rawUrl).trim());
    const host = hostname.toLowerCase();
    return platform.domains.some((d) => host === d || host.endsWith("." + d));
  } catch {
    return false;
  }
}
